import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// components
import { Callout } from 'components/ui';
import { Row, Col } from 'reactstrap';
import { PlatoonSelect, SoldierSelect, BaseSelect } from 'components/inputs';
import ModuleControlRow from '../module/ModuleControlRow';
// functions
import { setTitle } from 'functions/utils';
import { isAdmin, isBC } from 'functions/login';

// block_missions is whitelisted in mashpia.com/public/api/core/modules.php and
// enforced at grid creation in mashpia.com/public/mobile/getMissionPage.php
const module = {
  moduleKey: 'block_missions',
  title: 'Block missions',
  description: "Blocked soldiers won't be allowed to mark missions on the mobile site. Staff can still mark on their behalf."
};

function MissionAccessPage (props) {
  const { login } = props;
  const [ selections, setSelections ] = useState({ school_id: false, class_ids: [], user_ids: [] });
  const { school_id, class_ids, user_ids } = selections;
  const selectionScope = user_ids && user_ids.length ? 'user'
    : class_ids && class_ids.length ? 'class'
    : school_id ? 'school' : null;

  const selectionIds = user_ids && user_ids.length ? user_ids
    : class_ids && class_ids.length ? class_ids
    : school_id ? [school_id] : null;

  // componentDidMount
  useEffect(() => {
    setTitle('Mission Access');
    // set the default school id and class id
    const { school_id, class_id } = login;
    setSelections(() => ({ school_id, class_ids: class_id ? [class_id] : [] }));
  }, []);

  const schoolChange = ({ value }) => {
    setSelections(() => ({ school_id: parseInt(value, 10), class_ids: [], user_ids: [] }));
  };
  const multiSelectChange = key => values => {
    setSelections(prevState => ({ ...prevState, [key]: values.map(val => val.value) }));
  };

  return (
    <div id='MissionAccessPage'>
      <Callout title='Mission Access'>
        <p>
          Block soldiers from doing their missions on the mobile site, by base, platoons, or soldiers.
        </p>
      </Callout>

      <Row>
        <Col sm={6}>
          <label>Base</label>
          <BaseSelect
            name='school_id' onChange={schoolChange}
            value={school_id} isDisabled={!isAdmin(login.code)} />
          <input type='hidden' value={school_id} name='school_id' />
        </Col>

        <Col sm={6}>
          <label>Platoon(s)</label>
          <PlatoonSelect
            placeholder='All Platoons' isMulti values={class_ids}
            isDisabled={!isBC(login.code)} openMenuOnFocus={false}
            schoolId={school_id} onChange={multiSelectChange('class_ids')} />
          <input type='hidden' value={class_ids} name='class_ids' />
        </Col>

        <Col sm={6}>
          <label>Soldier(s)</label>
          <SoldierSelect
            values={user_ids} isMulti registeredOnly
            schoolId={school_id} classIds={class_ids} openMenuOnFocus={false}
            onChange={multiSelectChange('user_ids')} placeholder='All Soldiers' />
          <input type='hidden' value={user_ids} name='user_ids' />
        </Col>
      </Row>

      <hr />

      <ModuleControlRow
        {...module}
        selectionScope={selectionScope}
        selectionIds={selectionIds}
        selections={selections}
        />

    </div>
  );
}

const mapStateToProps = ({ login }) => ({
  login: login.current_login
});

export default connect(mapStateToProps)(MissionAccessPage);



// WEBPACK FOOTER //
// ./src/pages/base-managment/missionAccess/MissionAccessPage.jsx